import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import AdminDetailsForm from '../AdminsAdminDetailsForm';

import * as Styles from './_adminsDeleteAdminModal.module.scss';

const AdminsDeleteAdminModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.admin.modals.deleteAdminModalIsOpen);
    const userId = useAppSelector(state => state.admin.adminDetails.userId);
    const isLoading = useAppSelector(state => state.admin.loadings.deleteAdmin);
    const error = useAppSelector(state => state.admin.errors.deleteAdmin);
    const adminDetails = useAppSelector(state => state.admin.adminDetails);

    const handleModalOnClose = () => {
        dispatch(combinedActions.adminSetDeleteAdminModalIsOpen(false));
    };

    const handleOnSubmit = () => dispatch(combinedActions.adminDeleteAdminAttempt({ userId }));

    return (
        <Modal
            title='Delete Admin'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <AdminDetailsForm
                submitButtonLabel='Delete'
                actionButtonIsLoading={isLoading}
                actionButtonClassName={Styles['action-button']}
                onSubmit={() => handleOnSubmit()}
                inputIsDisabled={true}
                error={error}
                initialAdminDetails={adminDetails}
            />
        </Modal>
    );
};

export default AdminsDeleteAdminModal;
